import { TermsOfUseForManufacturerServicesSubPage } from '../TermsOfUseForManufacturerServicesSubPage';

export const ServiceContentCardCreatorPage = () => (
  <TermsOfUseForManufacturerServicesSubPage page="portal.termsOfUse.manufacturerServices.contentCardCreator" />
);
